import { PLUGIN_AUTH_TYPE, PLUGIN_RUNTIME } from '@fx-ui/open-sdk';

export const CUSTOM_AUTH_TYPE = [
    PLUGIN_AUTH_TYPE.BASIC_AUTH,
    PLUGIN_AUTH_TYPE.OAUTH2_CLIENT_CREDENTIALS,
    PLUGIN_AUTH_TYPE.OAUTH2_AUTHORIZATION_CODE
];

export const OAUTH2_ACCOUNT_FIELD_ID = 'account';

export const RUNTIME_LABEL: Record<PLUGIN_RUNTIME, string> = {
    [PLUGIN_RUNTIME.NODEJS12]: 'Node.js 12',
    [PLUGIN_RUNTIME.NODEJS20]: 'Node.js 20',
    [PLUGIN_RUNTIME.NODEJS24]: 'Node.js 24',
    [PLUGIN_RUNTIME.PYTHON36]: 'Python 3.6',
    [PLUGIN_RUNTIME.PYTHON310]: 'Python 3.10',
    [PLUGIN_RUNTIME.PYTHON314]: 'Python 3.14'
};
